export default __webpack_public_path__ + "static/media/p02 p04.164d8004.jpg";